<div class="skeleton-loader-container" *ngIf="skeletonData">
  <div *ngFor="let data of skeletonData">
    <ul [class]="data?.ul" *ngIf="data?.li">
      <li *ngFor="let list of data?.li" [class]="list?.listClass">
        <div *ngFor="let element of list.elements" [class]="element.class" ></div>
      </li>
    </ul>
    <!-- Below block is for div elements -->
    <div *ngIf="data?.divClass" [class]="data?.divClass">
      <div *ngFor="let element of data.elements" [class]="element.class"></div>
    </div>
  </div>
</div>
